import PropTypes from 'prop-types';

import React, { Fragment, useState, useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Button,
  Container,
  Stack,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import YourRecentActivity from "./YourRecentActivity";
import { useResponsive } from '../../hooks/use-responsive';

export default function DashHomeActiveUser({ userDetails }) {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const mdUp = useResponsive("up", "md");

  const navigate = useNavigate();
  // const getCookie = (name) => {
  //   const value = `; ${document.cookie}`;
  //   const parts = value.split(`; ${name}=`);
  //   if (parts.length === 2) return parts.pop().split(';').shift();
  // };
  // React.useEffect(() => {
  //   const accessToken =getCookie("accessToken");
  //   if (!accessToken) {
  //     setTimeout(() => {
  //       navigate("/");
  //     }, 100);

  //   }
  // }, [navigate]);

  const chartData = {
    labels: ['Youtube', 'Telegram', 'PowerPoint', 'Other'],
    datasets: [
      {
        data: [45, 25, 20, 10], // Percentage data for each section
        backgroundColor: ['#CDFF3E', '#00E5FF', '#FFB2E6', '#FF4C4C'], // Colors for each section
        hoverBackgroundColor: ['#B6F238', '#00D1E4', '#FFA3D4', '#FF3C3C'], // Hover colors
        borderWidth: 2,
        cutout: '70%', // Inner radius for the donut chart
      },
    ],
  };
  const [planName, setPlanName] = useState("");  // Initialize state for planName
  const [planAmt, setPlanAmt] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [daysLeft, setDaysLeft] = useState(0);
  const [isActive, setIsActive] = useState(true);
  useEffect(() => {
    let token = localStorage.getItem("accessToken");

    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .get(GET_USER,
        config,
        {
          withCredentials: true,
        })
      .then((response) => {
        const { paymentDetails } = response.data.user
        const formattedDate = formatDate(new Date(response.data.user.subscription_end_date));
        const daysLeft = calculateDaysLeft(response.data.user.subscription_end_date);

        setPlanName(paymentDetails.planName)
        setPlanAmt(paymentDetails.amount)
        setFormattedDate(formattedDate)
        setDaysLeft(daysLeft);
        setIsActive(daysLeft > 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const formatDate = (date) => {
    if (isNaN(date.getTime())) {
      return "-";  // Return dash if the date is invalid
    }
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Determine the suffix for the day
    let suffix = "th";
    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  };

  // Calculate how many days left until the plan expires
  const calculateDaysLeft = (validityDate) => {
    const today = new Date();
    const expiryDate = new Date(validityDate);
    const timeDifference = expiryDate - today;
    const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert ms to days
    return daysLeft;
  };

  const CreateNew = styled(Button)(({ theme }) => ({
    backgroundColor: "#C7F760",
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "& .icon-hover": {
      transition: "color 0.3s ease",
    },
    "&:hover": {
      backgroundColor: "#1E53E8",
      color: "#C7F760",
      "& .icon-hover": {
        color: "#FFFFFF", // Change the icon color to white on hover
      },
    },
  }));
  return (
    <Fragment>
      {mdUp && <Container
        maxWidth={false}
        sx={{
          // display: "flex",
          backgroundColor: "#B7FFFE",
          padding: "30px 20px",
          borderRadius: "20px",
          // maxWidth: '600px',
          // margin: "auto",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >

        <Grid
          container
          direction={{ lg: "row", sm: "column", md: "column" }}
          columnGap={{ lg: 3, md: 1, sm: 1 }}
          rowGap={3}
          sx={{ alignItems: { lg: 'center', md: 'flex-start', sm: 'flex-start' }, justifyContent: { lg: 'space-evenly', md: 'left', sm: 'space-evenly' }, justifyItems: 'center' }}
        >
          <Grid item xs={2} sx={3} md={3} justifyContent="center" alignItems="center">
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "65px",
                  maxWidth: "65px",
                  maxHeight: "65px",
                }}
              >
                <img
                  src="/assets/DashActivePlan.png"
                  alt="DashActivePlan"
                  style={{ maxWidth: "100%" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1D53E7",
                    fontWeight: "600",
                    fontStyle: "italic",
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Active Plan
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "600",
                    fontFamily: "Sofia Sans Extra Condensed",
                  }}
                >
                  {planName} Plan
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: "Roboto Flex" }}>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "22px",
                      color: isActive ? "#27AE60" : "#FF0000",
                    }}
                  >
                    {" "}
                    ●{" "}
                  </span>
                  {isActive ? "Active" : "Deactive"}
                </Typography>
              </Box>
            </Stack>
          </Grid>
          <Divider
            orientation="vertical"
            variant="inset"
            flexItem
            sx={{
              mx: 2, borderColor: '#858585',
              bgcolor: '#858585',
              width: '1px'
            }}
          />
          <Grid item xs={2} md={3} justifyContent="center" alignItems="center">
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "65px",
                  maxWidth: "65px",
                  maxHeight: "65px",
                }}
              >
                <img
                  src="/assets/DashBestAmount.png"
                  alt="DashBestAmount"
                  style={{ maxWidth: "100%" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1D53E7",
                    fontWeight: "600",
                    fontStyle: "italic",
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Base Amount
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "600",
                    fontFamily: "Sofia Sans Extra Condensed",
                  }}
                >
                  ₹{planAmt}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1D53E7",
                    fontFamily: "Roboto Flex",
                    textDecoration: "underline",
                  }}
                >
                  Upqrade or Renew
                </Typography>
              </Box>
            </Stack>
          </Grid>
          <Divider
            orientation="vertical"
            variant="inset"
            flexItem
            sx={{
              mx: 2, borderColor: '#858585',
              bgcolor: '#858585',
              width: '1px'
            }}
          />
          <Grid item xs={2} md={3} justifyContent="center" alignItems="center">
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "65px",
                  maxWidth: "65px",
                  maxHeight: "65px",
                }}
              >
                <img
                  src="/assets/DashValidity.png"
                  alt="DashValidity"
                  style={{ maxWidth: "100%" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1D53E7",
                    fontWeight: "600",
                    fontStyle: "italic",
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Validity
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "600",
                    fontFamily: "Sofia Sans Extra Condensed",
                    color: userDetails?.subscription_status === "Active" ? "black" : "#F03D55",
                  }}
                >
                  {formattedDate}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#1D53E7", fontFamily: "Roboto Flex" }}
                >
                  {formattedDate !== "-" ? (isActive ? `${daysLeft} Days Left` : "Expired") : null}
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

      </Container>}
      {/* {chartData && !chartData.length ? noData :
      <YourRecentActivity chartData={chartData} />   
     } */}

      {userDetails?.subscription_status === "Active" ?
        <YourRecentActivity chartData={chartData} /> :
        <Box sx={{ p: 2, mt: { xs: 0, md: 3 }, backgroundColor: '#F1F1F1', borderRadius: 5, width: 'auto', height: { xs: '657px', md: '532px' }, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
          <Stack direction='column'  >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              textAlign="center"
              sx={{
                color: '#1E53E8',
                fontSize: { xs: '28px', md: '38px' },
                fontFamily: 'Sofia Sans Extra Condensed',
                fontWeight: '700',
                lineHeight: { xs: '30px', md: '40px' },
                wordWrap: 'break-word',
                textTransform: "uppercase",
              }}
              gutterBottom
            >
              Create your own <br /> megaconnect cloud computer
            </Typography>
            <Grid
              container
              item
              justifyContent="center"
              md={12}
            >
              <CreateNew
                // onClick={}
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  color: "#1E53E8",
                  fontWeight: "bold",
                  background: "#C7F760",
                  padding: 1,
                  borderRadius: 2,
                }}
              >
                Create New
              </CreateNew>
            </Grid>
          </Stack>
        </Box>}
    </Fragment>

  );
}
DashHomeActiveUser.propTypes = {
  userDetails: PropTypes.object,
};